import React from "react";
import { useTranslation } from "react-i18next";
import { LOGO_URL } from "../lib/api";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const Login = () => {
  const { t } = useTranslation();

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const startGoogle = () => {
    const redirectUri = window.location.origin + "/auth/google";
    // Random state for CSRF protection — verified in the callback page
    const state = crypto
      .getRandomValues(new Uint8Array(16))
      .reduce((s, b) => s + b.toString(16).padStart(2, "0"), "");
    sessionStorage.setItem("imora_oauth_state", state);
    const params = new URLSearchParams({
      client_id: GOOGLE_CLIENT_ID,
      redirect_uri: redirectUri,
      response_type: "code",
      scope: "openid email profile",
      access_type: "online",
      prompt: "select_account",
      state,
    });
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
  };

  return (
    <div className="min-h-[calc(100vh-200px)] flex items-center justify-center px-4 py-10">
      <div className="bg-white border border-neutral-200 rounded-2xl p-8 max-w-md w-full text-center">
        <img src={LOGO_URL} alt="IMORA" className="h-16 w-16 mx-auto rounded-xl mb-4" />
        <h1 className="font-heading font-black text-3xl tracking-tighter mb-2">{t("login.title")}</h1>
        <p className="text-sm text-neutral-500 mb-6">{t("login.subtitle")}</p>
        <button
          onClick={startGoogle}
          data-testid="google-login-btn"
          className="w-full bg-white border-2 border-neutral-200 hover:border-neutral-900 h-12 px-6 rounded-lg font-bold flex items-center justify-center gap-3 transition"
        >
          <svg width="20" height="20" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
          </svg>
          {t("login.continueGoogle")}
        </button>
        <p className="text-xs text-neutral-400 mt-4">{t("login.terms")}</p>
        <a
          href="/admin-login"
          data-testid="admin-login-link"
          className="text-xs text-neutral-300 hover:text-neutral-600 mt-3 inline-block transition"
        >
          Accès administrateur
        </a>
      </div>
    </div>
  );
};

export default Login;
